import CustomEvents from "@/common/constants/customEvents";
import eventBus from "@/common/services/eventBus";
import { FileCenterContext } from "@/common/components/FileCenterProvider";
import { isSubscriptionAvailable } from "@/common/utils/utils";
import { Button, message } from "antd";
import { useContext } from "react";


function SignUpVipBtn() {
    const { userInfo, subscription } = useContext(FileCenterContext);
    const subAvailable = isSubscriptionAvailable(subscription);

    function openVipPanel() {
        eventBus.emit(CustomEvents.OPEN_VIP_PANEL);
    }

    const handleClick = () => {
        if (!userInfo) {
            message.warning('请先登录');
            eventBus.emit(CustomEvents.OPEN_LOGIN_PANEL, { callback: openVipPanel });
            return;
        }
        openVipPanel();
    }

    const text = (userInfo && subAvailable) ? '续费会员' : '开通会员';
    return (
        <Button type="primary" onClick={handleClick}>{text}</Button>
    );
}

export default SignUpVipBtn;